import { Navigate, createFileRoute } from "@tanstack/react-router";
import { SeatOrgKind } from "@sx/protocol/fleet/supervision";

import { TeleopSessionsPage } from "../../../workspaces/fleet/pages/TeleopSessionsPage";
import { useSeat } from "../../../workspaces/fleet/seat";

/** Every session a person drove, across the robots of every project this person reads. A
 * teleop vendor reads no fleet of its own; its home is the help queue. */
export const Route = createFileRoute("/_console/teleoperators/sessions")({
  component: Sessions,
});

function Sessions() {
  const seat = useSeat();
  if (seat.orgKind === SeatOrgKind.TELEOP_VENDOR) return <Navigate to="/teleoperators" replace />;
  return <TeleopSessionsPage />;
}
